import React from "react";
import styles from "./index.module.scss";
import c2mLogo from "../../assets/Logos/c2mdBlue.svg";

function PrescriptionDisplayComponent({ wholeData, appointmentHistoryRedux,clientDetails }) {
  console.info("PrescriptionDisplayComponent", wholeData);

  const localClinicDetails = JSON.parse(localStorage.getItem("ClinicDetails"));

  console.info("localClinicDetails", localClinicDetails);
  const prescriptionData = {
    clinicLogo: clientDetails?.logo||c2mLogo,
    date: "31-Jul-2017",
    doctorName: appointmentHistoryRedux?.[0].doctorName,
    doctorAddress: `M.D.(Med.), D.M.(Cardiology)
        Reg. No. : 12345
        Pokhran Road No. 2,
        Thane (W),
        Mumbai - 400610`,
    patientDetails: {
      name: appointmentHistoryRedux?.[0].patientName,
      gender:
        appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.gender,
      age: appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.age,
      Weight:
        appointmentHistoryRedux?.[0].patientDetails?.basicInfo?.weightValue,
      id: appointmentHistoryRedux?.[0].patientId,
      height:
        appointmentHistoryRedux?.[0].patientDetails?.basicInfo?.heightValue,
    },
    investigations: [
      { name: "CYSTOSCOPY", comment: "-" },
      { name: " INGUINAL HERNIA (LAP)", comment: "-" },
      { name: "# NECK FEMUR DHS IMPLANT", comment: "-" },
    ],
    medicines: [
      {
        type: "",
        name: "(PS)TRIATHLO N FEMUR LTNO 1",
        qty: "4H / 1",
        before: "",
        after: "",
        sos: "",
        duration: "1D",
        notes: "TEST",
      },
      {
        type: "",
        name: "2BACONIL PATCH 14MG/24HRS",
        qty: "4H / 1",
        before: "",
        after: "",
        sos: "",
        duration: "1D",
        notes: "TEST",
      },
    ],
  };

  function splitTextIntoChunks(text, chunkSize) {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    for (let i = 0; i < words.length; i++) {
      if ((currentChunk + words[i]).length <= chunkSize) {
        currentChunk += words[i] + " ";
      } else {
        chunks.push(currentChunk.trim());
        currentChunk = words[i] + " ";
      }
    }

    // Push the remaining text if any
    if (currentChunk.trim().length > 0) {
      chunks.push(currentChunk.trim());
    }
    return chunks;
  }

  const breakTextArrayIntoLines = (textArray) => {
    const maxLength = 30;
    let lines = [];

    textArray.forEach((text) => {
      let currentLine = "";
      for (let i = 0; i < text.length; i++) {
        currentLine += text[i];
        if (currentLine.length === maxLength) {
          lines.push(currentLine);
          currentLine = "";
        }
      }
      if (currentLine.length > 0) {
        lines.push(currentLine);
      }
    });

    return lines;
  };

  const displayName =
    appointmentHistoryRedux?.[0]?.appointmentFor === "Loved One"
      ? appointmentHistoryRedux?.[0]?.appointmentForName
      : appointmentHistoryRedux?.[0]?.patientName;

  return (
    <div className={styles.container}>
      <div className={styles.prescription_header}>
        <div className={styles.doctor_details}>
          <h6>{appointmentHistoryRedux?.[0].doctorName},</h6>
          <p>{appointmentHistoryRedux?.[0].doctorQualification}</p>
          <p>Reg. No. : {appointmentHistoryRedux?.[0].registrationNumber}</p>

          {/* // <p> Thane (W),</p>
          // <p> Mumbai - 400610.</p> */}
        </div>

        <img
          className={styles.clinic_logo}
          src={prescriptionData?.clinicLogo}
          alt="logo"
        />
      </div>

      <div className={styles.devider}>&nbsp;</div>

      <div className={styles.patient_details}>
        <div className={styles.patient_details_item}>
          <div>
            <p>Name: {displayName}</p>
            <p>
              Gender:{" "}
              {
                appointmentHistoryRedux?.[0].patientDetails?.personalDetails
                  ?.gender
              }
            </p>
            <p>
              Age:{" "}
              {
                appointmentHistoryRedux?.[0].patientDetails?.personalDetails
                  ?.age
              }
            </p>
          </div>
        </div>

        <div className={styles.patient_details_item}>
          <p>Pt.ID: {appointmentHistoryRedux?.[0].patientId}</p>
        </div>

        <div className={styles.patient_details_item}>
          <p>Date: {appointmentHistoryRedux?.[0].appointmentDate}</p>
        </div>
      </div>

      <div className={styles.patient_details}>
        <div className={styles.patient_details_item}>
          Weight (wherever applicable):{" "}
          {wholeData.weightValue &&
          wholeData.weightValue !== "0"          
            ? `${wholeData.weightValue} ${wholeData.weightMessurment}`
            : "NA"}
        </div>

        <div className={styles.patient_details_item}>
          Height (wherever applicable):{" "}
          {wholeData.heightValue &&
          wholeData.heightValue !== "0" 
            ? `${wholeData.heightValue} ${wholeData.heightMessurment}`
            : "NA"}
        </div>

        <div className={styles.patient_details_item}>
          LMP (wherever applicable):{" "}
          {wholeData?.lmp != "" ? wholeData?.lmp : "NA"}
        </div>
      </div>

      <div className={styles.devider}>&nbsp;</div>

      <table>
        {wholeData?.symptoms.length > 0 && (
          <tr>
            <td>
              <h4>SYMPTOMS</h4>
              <ul>
                {wholeData?.symptoms.map((each, index) => {
                  let symptomText = each.name;
                  let detailText = "";

                  if (each.detailData) {
                    let detailTextParts = Object.keys(each.detailData)
                      .filter((key) => key.toLowerCase() !== "note")
                      .map((key) => {
                        if (key === "Since" || key === "more") {
                          if (
                            key === "more" &&
                            Array.isArray(each.detailData[key])
                          ) {
                            return each.detailData[key].join(", ");
                          } else if (Array.isArray(each.detailData[key])) {
                            if (key === "Since") {
                              return ` ${each.detailData[key].join(", ")}`;
                            }
                            return null;
                          }
                          if (key === "Since") {
                            return ` ${each.detailData[key]}`;
                          }
                          return null;
                        } else if (
                          key === "Pustules" ||
                          key === "AUA Scoring"
                        ) {
                          if (key === "AUA Scoring") {
                            const auaScoring = each.detailData[key].join(", ");
                            const maxLength = 30;
                            const auaLines = [];
                            for (
                              let i = 0;
                              i < auaScoring.length;
                              i += maxLength
                            ) {
                              auaLines.push(auaScoring.slice(i, i + maxLength));
                            }
                            return `AUA Scoring: ${auaLines.join(", ")}`;
                          }
                          return `${
                            key.charAt(0).toUpperCase() + key.slice(1)
                          }: ${each.detailData[key].join(", ")}`;
                        } else if (key === "Grade") {
                          return Array.isArray(each.detailData[key])
                            ? each.detailData[key].join(", ")
                            : each.detailData[key];
                        }
                        return each.detailData[key];
                      })
                      .filter(Boolean);

                    detailText =
                      detailTextParts.length > 0
                        ? detailTextParts.join(", ").trim()
                        : "";

                        if (each.detailData.Note) {
                          let noteText = Array.isArray(each.detailData.Note)
                            ? each.detailData.Note.join(" ")
                            : each.detailData.Note;
                        
                          const maxLength = 30;
                          const noteLines = [];
                          let currentLine = "";
                        
                          noteText.split(" ").forEach((word) => {
                            if ((currentLine + word).length > maxLength) {
                              noteLines.push(currentLine.trim());
                              currentLine = word + " ";
                            } else {
                              currentLine += word + " ";
                            }
                          });
                        
                          if (currentLine) {
                            noteLines.push(currentLine.trim()); // Push the last line
                          }
                        
                          const formattedNote = noteLines.join("\n");
                        
                          if (detailText) {
                            detailText += `, ${formattedNote}`;
                          } else {
                            detailText = formattedNote;
                          }
                        }
                        

                    detailText = detailText.replace(/,(\s+)?$/, ""); // Remove trailing comma
                  }

                  // Only add the hyphen and detail text if there's actually detail text
                  if (detailText) {
                    symptomText += ` - ${detailText}`;
                  }

                  return <li key={index}>{symptomText}</li>;
                })}
              </ul>

              {wholeData?.symptomsNote && (
                <>
                  <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                    Note:{" "}
                    {splitTextIntoChunks(wholeData?.symptomsNote, 110).map(
                      (chunk, index) => (
                        <React.Fragment key={index}>
                          {index !== 0 && <br />}
                          {chunk}
                        </React.Fragment>
                      )
                    )}
                  </p>
                </>
              )}
            </td>
          </tr>
        )}

        {wholeData?.medicalHistory?.length > 0 ?(
          <>
            <tr>
              <td>
                <h4>MEDICAL HISTORY</h4>
                <ul>
                  {wholeData?.medicalHistory.map((each, index) => (
                    <li key={index}>{each.name}</li>
                  ))}
                </ul>

                {wholeData?.medicalHistoryNote && (
                  <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                    {" "}
                    Note:{" "}
                    {splitTextIntoChunks(wholeData?.medicalHistoryNote, 110).map(
                      (chunk, index) => (
                        <React.Fragment key={index}>
                          {index !== 0 && <br />}
                          {chunk}
                        </React.Fragment>
                      )
                    )}
                  </p>
                )}
                {wholeData?.vaccinationStatus && (
                  <>
                    {wholeData?.vaccinationStatus === "Yes" ? (
                      <p>
                        Vaccine Status: {wholeData?.vaccinationStatus},{" "}
                        {wholeData?.vaccinationDoseCount},{" "}
                        {Array.from(
                          {
                            length: parseInt(wholeData?.vaccinationDoseCount),
                          },
                          (_, index) => {
                            const vaccineName =
                              wholeData[`vaccinationName${index + 1}`];
                            return vaccineName ? `• ${vaccineName} ` : "";
                          }
                        )}
                      </p>
                    ) : (
                      <>
                        <p>
                          Vaccine Status: {wholeData?.vaccinationStatus}
                          {/* {wholeData.nonVaccinationReason} */}
                        </p>
                      </>
                    )}
                  </>
                )}
              </td>
            </tr>
          </>
        ):
        wholeData?.vaccinationStatus && (
          <>
          <tr>
              <td>
                <h4>MEDICAL HISTORY</h4>
            {wholeData?.vaccinationStatus === "Yes" ? (
              <p>
                Vaccine Status: {wholeData?.vaccinationStatus},{" "}
                {wholeData?.vaccinationDoseCount},{" "}
                {Array.from(
                  {
                    length: parseInt(wholeData?.vaccinationDoseCount),
                  },
                  (_, index) => {
                    const vaccineName =
                      wholeData[`vaccinationName${index + 1}`];
                    return vaccineName ? `• ${vaccineName} ` : "";
                  }
                )}
              </p>
            ) : (
              <>
                <p>
                  Vaccine Status: {wholeData?.vaccinationStatus}
                  {/* {wholeData.nonVaccinationReason} */}
                </p>
              </>
            )}
            </td>
            </tr>
          </>
        )
        }


        {wholeData?.familyHistoryNote.length > 0 && (
          <>
            <tr>
              <td>
                <h4>FAMILY HISTORY</h4>
                {wholeData?.familyHistoryNote && (
                  <>
                    {/* {wholeData.familyHistoryNote.map((each, key) => {
                      return <></>;
                    })} */}
                    <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                      {" "}
                      Note:{" "}
                      {splitTextIntoChunks(
                        wholeData?.familyHistoryNote,
                        110

                      ).map((chunk, index) => (
                        <React.Fragment key={index}>
                          {index !== 0 && <br />}
                          {chunk}
                        </React.Fragment>
                      ))}{" "}
                    </p>
                  </>
                )}
              </td>
            </tr>
          </>
        )}

        {wholeData?.examinations.length > 0 && (
          <tr>
            <td>
              <h4>EXAMINATION</h4>
              <ul>
                {wholeData?.examinations.map((each, index) => {
                  let examinationText = each.name;
                  let combinedText = "";

                  if (each.detailData) {
                    let detailTextParts = Object.keys(each.detailData)
                      .filter(
                        (key) =>
                          key !== "Note" &&
                          key !== "Readings" &&
                          key !== "Status"
                      )
                      .map((key) => {
                        if (
                          [
                            "Pallor",
                            "FHS",
                            "Presentation",
                            "Uterus",
                            "Fornices",
                          ].includes(key)

                        ) {
                          return `${
                            key.charAt(0).toUpperCase() + key.slice(1)
                          }: ${each.detailData[key].join(", ")}`;
                        }
                        return each.detailData[key];
                      })
                      .filter(Boolean);

                    let detailText = detailTextParts.join(", ");

                    let statusText = each.detailData.Status
                      ? Array.isArray(each.detailData.Status)
                        ? each.detailData.Status.join(", ")
                        : each.detailData.Status
                      : "";

                    let readingText = "";
                    if (each.detailData.Readings) {
                      readingText = each.detailData.Readings;
                      const readingsChunks = [];
                      for (let i = 0; i < readingText.length; i += 50) {
                        readingsChunks.push(readingText.slice(i, i + 50));

                      }
                      readingText = readingsChunks.join("\n");
                    }

                    let noteText = "";

                    if (each.detailData.Note) {
                      let noteContent = Array.isArray(each.detailData.Note)
                        ? each.detailData.Note.join(", ")
                        : each.detailData.Note;
                      const noteLines = [];
                      for (let i = 0; i < noteContent.length; i += 80) {
                        noteLines.push(noteContent.slice(i, i + 80));
                      }
                      noteText = noteLines.join("\n");
                    }

                    combinedText = [
                      statusText,
                      readingText,
                      detailText,
                      noteText,
                    ]
                      .filter((text) => text.length > 0)
                      .join(", ");

                    combinedText = combinedText.replace(/,(\s+)?$/, ""); // Remove trailing comma
                  }

                  // Only add the hyphen and combined text if there's actually combined text
                  if (combinedText) {

                    examinationText += ` - ${combinedText}`;
                  }

                  console.debug("examinationText", examinationText); // Final output

                  return (
                    <li key={index}>
                      <div>{examinationText}</div>
                    </li>
                  );
                })}
              </ul>
            </td>
          </tr>
        )}

        {wholeData?.diagnosticNote.length > 0 && (
          <>
            <tr>
              <td>
                <h4>DIAGNOSTIC REPORTS</h4>
                <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                  Note:&nbsp;
                  {splitTextIntoChunks(wholeData?.diagnosticNote, 110).map(
                    (chunk, index) => (
                      <React.Fragment key={index}>
                        {index !== 0 && <br />}
                        {chunk}
                      </React.Fragment>
                    )
                  )}
                </p>
              </td>
            </tr>
          </>
        )}

        {wholeData?.Diagnosis && wholeData?.Diagnosis.length > 0 && (
          <tr>
            <td>
              <h4>PROVISIONAL / FINAL DIAGNOSIS</h4>
              <ul>
                {wholeData?.Diagnosis.map((each, index) => (
                  <li key={index}>{each.name}</li>
                ))}
              </ul>
              {wholeData?.diagnosisNote &&
                wholeData?.diagnosisNote.length > 0 && (
                  <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                    Note:&nbsp;
                    {splitTextIntoChunks(wholeData?.diagnosisNote, 110).map(
                      (chunk, index) => (
                        <React.Fragment key={index}>
                          {index !== 0 && <br />}
                          {chunk}
                        </React.Fragment>
                      )
                    )}
                  </p>
                )}
            </td>
          </tr>
        )}
      </table>

      {wholeData?.investigations.length > 0 && (
        <>
          <h5>INVESTIGATIONS</h5>
          <table className={styles.investigation_table}>
            <tbody>
              {wholeData?.investigations.map((each, index) => {
                // Process detailData.note for splitting
                let noteText = "";
                if (each.detailData && each.detailData.note) {
                  noteText = Array.isArray(each.detailData.note)
                    ? each.detailData.note.join(" ")
                    : each.detailData.note;
                }

                // Break noteText into lines of 50 characters
                const maxLength = 80;
                const noteLines = [];
                let line = "";
                for (let i = 0; i < noteText.length; i++) {
                  line += noteText[i];
                  if (line.length === maxLength || noteText[i] === "\n") {
                    noteLines.push(line);
                    line = "";
                  }
                }
                if (line.length > 0) {
                  noteLines.push(line);
                }
                const formattedNote = noteLines.join("\n");

                return (
                  <tr key={index}>
                    <td>
                      <ul>
                        <li> {each?.name} </li>
                      </ul>
                      {formattedNote && <p>Note: {formattedNote}</p>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}

      {wholeData?.medications.length > 0 && (
        <>
          <h5>MEDICATIONS</h5>

          <table className={styles.medicine_table}>
            <thead>
              <tr>
                <th>
                  <div>MEDICINE</div>
                  <span>(BRAND/CHEMICALNAME)</span>
                </th>
                <th>FREQUENCY / DOSE</th>
                <th>WHEN TO USE</th>

                <th>DURATION</th>
                <th>NOTES</th>
              </tr>
            </thead>
            <tbody>
              {wholeData?.medications.map((each, key) => {
                // Process note for splitting
                let noteText = "";
                if (each.detailData && each.detailData.note) {
                  noteText = Array.isArray(each.detailData.note)
                    ? each.detailData.note.join(" ")
                    : each.detailData.note;
                }

                // Break noteText into lines of 80 characters
                const maxLength = 40;
                const noteLines = [];
                let line = "";
                for (let i = 0; i < noteText.length; i++) {
                  line += noteText[i];
                  if (line.length === maxLength || noteText[i] === "\n") {
                    noteLines.push(line);
                    line = "";
                  }
                }
                if (line.length > 0) {
                  noteLines.push(line);
                }
                const formattedNote = noteLines.join("\n");

                return (
                  <tr key={key}>
                    <td>
                      {each?.name}{" "}
                      {each?.genericname !== undefined &&
                        each?.genericname !== "" && (
                          <p style={{ fontStyle: "italic" }}>
                            ({each?.genericname})
                          </p>
                        )}
                    </td>
                    <td>
                      {each?.detailData?.default_timing !== undefined
                        ? each?.detailData?.default_timing + " / "
                        : "-/"}{" "}
                      {each?.detailData?.quantity !== undefined
                        ? each?.detailData?.quantity
                        : "-"}{" "}
                      {each?.detailData?.quantity !== undefined &&
                      each?.detailData?.quantity_messurment !== undefined
                        ? each?.detailData?.quantity_messurment
                        : ""}
                    </td>
                    <td>
                      {each?.detailData?.default_timing_custom !== undefined
                        ? each?.detailData?.default_timing_custom
                        : "-"}
                    </td>
                    <td>
                      {each?.detailData?.custom_duration !== undefined
                        ? each?.detailData?.custom_duration
                        : "-"}
                    </td>
                    <td>{formattedNote !== "" ? formattedNote : "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}

      <table>
        {wholeData?.instructions.length > 0 || wholeData?.diet !== undefined ? (
          <tr>
            <td>
              <h4>SPECIAL INSTRUCTIONS / DIET</h4>
              <ul>
                {wholeData?.instructions.map((each, index) => (
                  <p key={index}>
                    <li>{each.name}</li>
                  </p>
                ))}

                {wholeData?.diet !== undefined && (
                  <p>DIET: {wholeData?.diet}</p>
                )}
                {wholeData.instructionNote && (
                  <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                    Note:{" "}
                    {splitTextIntoChunks(wholeData.instructionNote, 100).map(
                      (chunk, index) => (
                        <React.Fragment key={index}>
                          {index !== 0 && <br />}
                          {chunk}
                        </React.Fragment>
                      )
                    )}
                  </p>
                )}
              </ul>
            </td>
          </tr>
        ) : null}

        {/* <h4>Prescription For Glasses</h4> */}
        {/* <table>
          <tr>
            <th></th>
            <th colspan="4" style={{textAlign:"center"}}>Right Eye</th>
            <th colspan="4" style={{textAlign:"center"}}>Left Eye</th>
          </tr>
          <tr>
            <th></th>
            <th style={{textAlign:"center"}}>SPH</th>
            <th style={{textAlign:"center"}}>CYL</th>
            <th style={{textAlign:"center"}}>AXIS</th>
            <th style={{textAlign:"center"}}>VA</th>
            <th style={{textAlign:"center"}}>SPH</th>
            <th style={{textAlign:"center"}}>CYL</th>
            <th style={{textAlign:"center"}}>AXIS</th>
            <th style={{textAlign:"center"}}>VA</th>
          </tr>
          <tr>
            <th>DIST</th>
            {wholeData?.rightEyeData && (
              <>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[0]?.detailData?.SPH[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[0]?.detailData?.CYL[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[0]?.detailData?.AXIS[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[0]?.detailData?.VA[0]}</th>
              </>
            )}
            {wholeData?.leftEyeData && (
              <>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[0]?.detailData?.SPH[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[0]?.detailData?.CYL[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[0]?.detailData?.AXIS[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[0]?.detailData?.VA[0]}</th>
              </>
            )}
          </tr>

          <tr>
            <th>NEAR</th>
            {wholeData?.rightEyeData && (
              <>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[1]?.detailData?.SPH[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[1]?.detailData?.CYL[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[1]?.detailData?.AXIS[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.rightEyeData[1]?.detailData?.VA[0]}</th>
              </>
            )}
            {wholeData?.leftEyeData && (
              <>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[1]?.detailData?.SPH[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[1]?.detailData?.CYL[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[1]?.detailData?.AXIS[0]}</th>
                <th style={{textAlign:"center"}}>{wholeData.leftEyeData[1]?.detailData?.VA[0]}</th>
              </>
            )}
          </tr>
         
        </table>
        <p style={{marginTop:"5px"}}>Type of Glasses: {wholeData?.typeOfGlasses}</p>
          <p>Recommendations: {wholeData?.recommend}</p> */}

        {wholeData?.followUpDate.length > 0 && (
          <tr>
            <td>
              <h4>Follow Up </h4>
              <span>{wholeData?.followUpDate}</span>
              {wholeData.followUpNote && (
                <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                  Note:{" "}
                  {splitTextIntoChunks(wholeData.followUpNote, 100).map(
                    (chunk, index) => (
                      <React.Fragment key={index}>
                        {index !== 0 && <br />}
                        {chunk}
                      </React.Fragment>
                    )
                  )}
                </p>
              )}
            </td>
          </tr>
        )}
        {wholeData?.referral != "" && (
          <tr>
            <td>
              <h4>Referral</h4>
              <p>Specialty: {wholeData?.speciality}</p>
              <p>Doctor Name: {wholeData?.referral}</p>
              {wholeData?.referralNote != "" && (
                <p style={{whiteSpace:"nowrap", wordWrap:"break-word"}}>
                  Note:{" "}
                  {splitTextIntoChunks(wholeData?.referralNote, 110).map(
                    (chunk, index) => (
                      <React.Fragment key={index}>
                        {index !== 0 && <br />}
                        {chunk}
                      </React.Fragment>
                    )
                  )}
                </p>
              )}
            </td>
          </tr>
        )}
      </table>

      <div className={styles.footer_signature_wrap}>
        <span>{appointmentHistoryRedux?.[0].doctorName}</span>
        <span>{wholeData?.doctorQualification}</span>
      </div>
    </div>
  );
}

export default PrescriptionDisplayComponent;
